<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { cl_errorMessage } from '@/api';
import { useLearnerStore } from '@/stores/learner';

const cl_learner = useLearnerStore(); const cl_router = useRouter();
const cl_name = ref(''); const cl_birthYear = ref<number>(); const cl_error = ref(''); const cl_loading = ref(false);
async function cl_create() { cl_loading.value = true; try { await cl_learner.cl_create(cl_name.value, cl_birthYear.value); await cl_router.push('/'); } catch (cl_cause) { cl_error.value = cl_errorMessage(cl_cause); } finally { cl_loading.value = false; } }
</script>

<template>
  <section class="cl-centered-page"><div class="cl-panel cl-onboarding"><p class="cl-eyebrow">建立学习档案</p><h1>今天谁来练习？</h1><form @submit.prevent="cl_create"><label>孩子的名字或昵称<input v-model.trim="cl_name" required maxlength="24" /></label><label>出生年份（选填）<input v-model.number="cl_birthYear" type="number" min="2014" :max="new Date().getFullYear()" inputmode="numeric" /></label><p v-if="cl_error" class="cl-form-error">{{ cl_error }}</p><button class="cl-primary-button" :disabled="cl_loading">开始学习</button></form></div></section>
</template>
